import { EJNotifications } from '../../../cimsPage/instances/ej'
import { Notifications } from '../../common'

const { Edit, View } = Notifications({
  page: EJNotifications,
  view: '75a6924a-53a7-45c8-bb9d-0d556078d682',
  edit: '13bee10b-7daf-49bd-b63e-fd42eb5add3d',
})

export const ViewEJNotification = View
export const EditEJNotification = Edit

export type EJNotificationPermission =
  | typeof ViewEJNotification
  | typeof EditEJNotification
